const Blog = {
  handleElementsVisibility: function () {
    const blogHeader = document.querySelector("[data-blog-header]");
    const postsList = document.querySelector("[data-posts-list]");
    const postContent = document.querySelector("[data-post-content]");

    if (blogHeader != null)
      setTimeout(() => {
        blogHeader.classList.add("-visible");
      }, 1000);

    if (postsList != null)
      setTimeout(() => {
        postsList.classList.add("-visible");
      }, 1000);

    if (postContent != null)
      setTimeout(() => {
        postContent.classList.add("-visible");
      }, 1000);  
  },

  init: function () {
    const { handleElementsVisibility } = Blog;
    
    handleElementsVisibility();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Blog.init();
});